import type { SxProps, Theme } from '@mui/material'
import { HEADER_HEIGHT, headerOffsetCss } from './layoutConstants'

const MAIN_PADDING = { xs: 1.5, md: 3 } as const

/** Shared main column padding and safe-area insets for app and admin shells. */
export const appMainContentSx: SxProps<Theme> = {
  flexGrow: 1,
  p: MAIN_PADDING,
  paddingBottom: (theme) => ({
    xs: `calc(${theme.spacing(MAIN_PADDING.xs)} + env(safe-area-inset-bottom, 0px))`,
    md: `calc(${theme.spacing(MAIN_PADDING.md)} + env(safe-area-inset-bottom, 0px))`,
  }),
  backgroundColor: 'background.default',
}

export function appMainWithHeaderOffsetSx(extraTop = 0): SxProps<Theme> {
  return {
    ...appMainContentSx,
    marginTop: extraTop
      ? `calc(${HEADER_HEIGHT + extraTop}px + env(safe-area-inset-top, 0px))`
      : headerOffsetCss,
    minHeight: `calc(100vh - ${HEADER_HEIGHT + extraTop}px - env(safe-area-inset-top, 0px))`,
  }
}

/** Spacer so drawer nav starts below the fixed header (including safe-area). */
export const headerSafeAreaSpacerSx = {
  height: headerOffsetCss,
  flexShrink: 0,
} as const
